/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureApimResourceGroupDetails {
    getFixupPrototypeFunction() { return AzureApimResourceGroupDetails.fixupPrototype; }

    static newInstance(model: Partial<AzureApimResourceGroupDetails>): AzureApimResourceGroupDetails {
        let obj = Object.assign(new AzureApimResourceGroupDetails(), model);
        AzureApimResourceGroupDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureApimResourceGroupDetails>): AzureApimResourceGroupDetails {
        if (!model) return null;
        return AzureApimResourceGroupDetails.newInstance(<AzureApimResourceGroupDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureApimResourceGroupDetails) {
        if (!obj) return;

        models.AzureApimResourceGroupDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureApimResourceGroupDetails): boolean {
        Object.setPrototypeOf(obj, AzureApimResourceGroupDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.apim_details) {
            for (let val of this.apim_details) {
                models.AzureApimDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Resource group the API Management services were selected from
     */
    resource_group: string;

    /**
     * API Management services selected from this resource group
     */
    apim_details: Array<models.AzureApimDetails>;

}
